(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANIMATION = void 0;

var _ui = require("../partials/ui");

var ANIMATION = function () {
  var circle1 = $('.circle1');
  var circle2 = $('.circle2');
  var servicesList = $('.services-list');
  var brush = $('#brush');
  var brush2 = $('#brush2');
  var phone = $('.industries-img__phone');
  var industriesList = $('.industries-list');
  var circle = $('.circle');
  var solutionsPhone = $('.solutions-images__phone');
  var memeMackbook = $('.mememachine-img__mackbook');

  function animateLineServices() {
    var circle1_h = $('.circle1-h');
    var circle2_h = $('.circle2-h');
    var stroke = $('.stroke');
    animateElement(circle1);
    animateElement(circle2);
    stroke.toArray().forEach(function (s) {
      return animateElement($(s));
    });
    circle1_h.toArray().forEach(function (s) {
      return animateElement($(s));
    });
    circle2_h.toArray().forEach(function (s) {
      return animateElement($(s));
    });
  }

  function animateServicesPage() {
    if (window.innerWidth > 730) {
      animateElement(servicesList);
    } else {
      $(servicesList).addClass('show');
    }
  }

  function animateIndustryPage() {
    animateElement(brush);
    setTimeout(animateIndustries, 60);
  }

  function animateIndustries() {
    animateElement(phone);
    animateElement(industriesList);
  }

  function animateSolutions() {
    animateElement(circle);
    setTimeout(function () {
      animateElement(solutionsPhone);
    }, 300);
  }

  function animateMemeMachine() {
    animateElement(brush2);
    setTimeout(function () {
      animateElement(memeMackbook);
    }, 60);
  }

  var onLoad = function onLoad() {
    $(window).on('DOMContentLoaded load resize scroll', animate);
  };

  var animate = function animate() {
    setTimeout(animateLineServices, 500);
    setTimeout(animateServicesPage, 500);
    setTimeout(animateIndustryPage, 500);
    setTimeout(animateSolutions, 500);
    setTimeout(animateMemeMachine, 500);
  };

  var animateElement = function animateElement(elem) {
    if (_ui.UI.isInView(elem)) {
      elem.addClass('animate');
    }
  };

  return {
    onLoad: onLoad,
    animateMemeMachine: animateMemeMachine,
    animateLineServices: animateLineServices
  };
}();

exports.ANIMATION = ANIMATION;

},{"../partials/ui":12}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOMSMARTSCROLL = void 0;

var _this = void 0;

var CUSTOMSMARTSCROLL = function () {
  var sections = $('section');
  var id = 0;
  var isRun = false;
  var isScrolling = false;
  var scrollingEvent = new Event('scrollFinish');

  var throttle = function throttle(callback, wait) {
    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this;
    var time = Date.now();
    var isScroll = false;
    return function () {
      var space = Date.now() - time;
      time = Date.now();

      if (!isScroll && space > 40) {
        isScroll = true;
        callback.apply(context, arguments);
        setTimeout(function () {
          return isScroll = false;
        }, wait);
      }
    };
  };

  var scrollTo = function scrollTo(elem, time) {
    isScrolling = true;
    $('html, body').animate({
      scrollTop: elem.offset().top - 1
    }, time, function () {
      isScrolling = false;
      document.dispatchEvent(scrollingEvent);
    });
  };

  var scrolling = function scrolling(event) {
    if (event.deltaY > 0 && id < sections.length - 1) {
      id++;
    } else if (event.deltaY < 0 && id > 0) {
      id--;
    }

    scrollTo($(sections[id]), 800);
  };

  var throttleScroll = throttle(scrolling, 800);
  return {
    runScroll: function runScroll(elem) {
      if (window.innerWidth > 768 && window.innerHeight >= 710 && !isRun) {
        document.addEventListener('wheel', throttleScroll);
        isRun = true;
      }
    },
    stopScroll: function stopScroll() {
      if (isRun) {
        document.removeEventListener('wheel', throttleScroll);
        isRun = false;
      }
    },
    blockScroll: function blockScroll(isBlock) {
      var body = $('#body');

      if (isBlock) {
        var top = window.pageYOffset;
        body.addClass('scroll-hidden');
        body[0].style.top = -top + 'px';
      } else {
        var _scrollTo = parseInt(body[0].style.top, 10);

        body.removeClass('scroll-hidden');
        window.scroll(0, -_scrollTo);
      }
    },
    scrollToSection: function scrollToSection(elem, time) {
      id = sections.toArray().findIndex(function (el) {
        return el === elem[0];
      });
      scrollTo(elem, time);
    },
    getId: function getId() {
      return id;
    },
    getIsRun: function getIsRun() {
      return isRun;
    },
    getIsScrolling: function getIsScrolling() {
      return isScrolling;
    }
  };
}();

exports.CUSTOMSMARTSCROLL = CUSTOMSMARTSCROLL;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMS = void 0;

var _customSmartscroll = require("./custom-smartscroll");

var _validation = require("../partials/validation");

var _popup = require("./popup");

var _ui = require("../partials/ui");

var FORMS = function () {
  var overlay = $('#overlay-us');
  var writeButton = $('#write-button');
  var contact = $('#contact-us');
  var consultingForm = $('#consulting-form');
  var writeUsForm = $('#write-us-form');
  var getPdfForm = $('#get-pdf-form');
  var consultingFormWrapper = $('#consulting-form--wrapper');
  var formCloseEvent = new Event('formClose');
  var formIsOpen = false;

  var addFormListeners = function addFormListeners() {
    hideWriteButtonOnScroll();
    writeButton.click(clickOnWriteButton);
    overlay.click(clickOnOverlay);
    $('#download-button').click(function () {
      return openForm(consultingForm[0]);
    });
    $('#consulting-close-button').click(function () {
      return closeForm(consultingForm[0]);
    });
  };

  var closeForm = function closeForm(form) {
    switch (form) {
      case consultingForm[0]:
        formIsOpen = false;
        document.dispatchEvent(formCloseEvent);
        return closeConsultingForm();

      case writeUsForm[0]:
        formIsOpen = false;
        document.dispatchEvent(formCloseEvent);
        return closeWriteUsForm();

      case getPdfForm[0]:
        return _popup.POPUP.hide();

      default:
        break;
    }
  };

  var openForm = function openForm(form) {
    switch (form) {
      case consultingForm[0]:
        formIsOpen = true;
        return openConsultingForm();

      case writeUsForm[0]:
        formIsOpen = true;
        return openWriteUsForm();

      case getPdfForm[0]:
        return _popup.POPUP.hide();

      default:
        break;
    }
  };

  var openWriteUsForm = function openWriteUsForm() {
    _validation.VALIDATION.addFormListeners(writeUsForm[0]);

    overlay.toggleClass('overlay-hide overlay-show');
    writeButton.toggleClass('btn-round__mail  btn-round__close');

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(true);

    _customSmartscroll.CUSTOMSMARTSCROLL.stopScroll();
  };

  var closeWriteUsForm = function closeWriteUsForm() {
    _validation.VALIDATION.resetForm(writeUsForm[0]);

    overlay.toggleClass('overlay-show overlay-hide');
    writeButton.toggleClass('btn-round__close btn-round__mail');

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(false);

    _customSmartscroll.CUSTOMSMARTSCROLL.runScroll();
  };

  var openConsultingForm = function openConsultingForm() {
    consultingFormWrapper.removeClass('hide');

    _validation.VALIDATION.addFormListeners(consultingForm[0]);

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(true);

    _customSmartscroll.CUSTOMSMARTSCROLL.stopScroll();
  };

  var closeConsultingForm = function closeConsultingForm() {
    consultingFormWrapper.addClass('hide');

    _validation.VALIDATION.resetForm(consultingForm[0]);

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(false);

    _customSmartscroll.CUSTOMSMARTSCROLL.runScroll();
  };

  var clickOnWriteButton = function clickOnWriteButton() {
    if (overlay.hasClass('overlay-hide')) {
      openForm(writeUsForm[0]);
    } else {
      closeForm(writeUsForm[0]);
    }
  };

  var clickOnOverlay = function clickOnOverlay(event) {
    if ($(event.target).closest($('#popup')).length === 0 && overlay.hasClass('overlay-show')) {
      closeForm(writeUsForm[0]);
    }
  };

  var hideWriteButtonOnScroll = function hideWriteButtonOnScroll() {
    $(window).on('scroll', function () {
      _ui.UI.isInView(contact) || window.pageYOffset >= contact[0].offsetTop ? writeButton.hide() : writeButton.show();
    });
  };

  return {
    addFormListeners: addFormListeners,
    closeForm: closeForm,
    openForm: openForm,
    getFormIsOpen: function getFormIsOpen() {
      return formIsOpen;
    }
  };
}();

exports.FORMS = FORMS;

},{"../partials/ui":12,"../partials/validation":13,"./custom-smartscroll":2,"./popup":6}],4:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HANDLEBARS = void 0;

var _animation = require("./animation");

var _service = require("../partials/service");

var VARIABLES = _interopRequireWildcard(require("../partials/variables"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HANDLEBARS = function () {
  var addServices = function addServices(service) {
    var source = $('#services-template').html();
    var template = Handlebars.compile(source);
    $('#services').html(template(service));
  };

  var addLocation = function addLocation() {
    var source = $('#location').html();
    var template = Handlebars.compile(source);

    _service.SERVICE.getLocation().done(function (data) {
      $('#city').html(template(data.city));
    }).fail(function () {
      $('#city').html(template('YOUR CITY'));
    });
  };

  var addIndustries = function addIndustries() {
    var source = $('#industries-template').html();
    var template = Handlebars.compile(source);
    $('#industries-left').html(template(VARIABLES.industries1));
    $('#industries-right').html(template(VARIABLES.industries2));
  };

  var addMemeMachine = function addMemeMachine(machineNumber) {
    var tabNumber = machineNumber ? machineNumber : 0;
    var source = $('#mememachine-template').html();
    var template = Handlebars.compile(source);
    $('#mememachine').html(template(VARIABLES.mememachine.data[tabNumber]));
    addMemeName(tabNumber);
    addMemeImg(tabNumber);

    _animation.ANIMATION.animateLineServices();
  };

  var addMemeName = function addMemeName(pageNumber) {
    var source = $('#mememachine-name').html();
    var template = Handlebars.compile(source);
    var mem_name = $('#mem-name');
    mem_name.addClass("memachine-name-".concat(pageNumber));
    mem_name.html(template(VARIABLES.mememachine.name[pageNumber]));
  };

  var addMemeImg = function addMemeImg(pageNumber) {
    var img = $('#mem-img');
    var img_wrapper = $('#mem-img--wrapper');

    if (img.hasClass('animate')) {
      img_wrapper.removeClass('mememachine-img--show');
      setTimeout(function () {
        img_wrapper.addClass('mememachine-img--show');
        $(img).attr('src', "img/".concat(VARIABLES.mememachine.img[pageNumber].src, ".png"));
        $(img).attr('alt', "".concat(VARIABLES.mememachine.img[pageNumber].alt));
        $(img).attr('title', "".concat(VARIABLES.mememachine.img[pageNumber].title));
      }, 10);
    } else {
      $(img).attr('src', "img/".concat(VARIABLES.mememachine.img[pageNumber].src, ".png"));
      $(img).attr('alt', "".concat(VARIABLES.mememachine.img[pageNumber].alt));
      $(img).attr('title', "".concat(VARIABLES.mememachine.img[pageNumber].title));
    }
  };

  var addPartners = function addPartners(pagesLength) {
    var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var source = $('#partners-template').html();
    var template = Handlebars.compile(source);
    var partners = $('#partners');

    if (window.innerWidth > 730) {
      partners.html(template(VARIABLES.partners));
    } else {
      var pages = VARIABLES.partners.reduce(function (resultArray, item, index) {
        var chunkIndex = Math.floor(index / pagesLength);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      partners.html(template(pages[pageNumber]));
    }
  };

  var addToast = function addToast(toast) {
    var source = $('#toast-template').html();
    var template = Handlebars.compile(source);
    $('#toast-wrapper').html(template(toast));
    setTimeout(function () {
      return $('#toast').addClass('toast-hide');
    }, 5000); //setTimeout(() => $('#toast').empty(), 5000);
  };

  var loadPage = function loadPage() {
    addLocation();
    addToast(VARIABLES.toasts);
    addIndustries();
    addServices(VARIABLES.services[0]);
    addMemeMachine(0);
    addPartners(8);
  };

  return {
    addIndustries: addIndustries,
    addToast: addToast,
    loadPage: loadPage,
    rerenderPage: function rerenderPage(i, name) {
      switch (name) {
        case 'services':
          addServices(VARIABLES.services[0]);
          return;

        case 'machine':
          addMemeMachine(i);
          return;

        case 'partners':
          addPartners(8, i);
          return;

        default:
          break;
      }
    }
  };
}();

exports.HANDLEBARS = HANDLEBARS;

},{"../partials/service":11,"../partials/variables":15,"./animation":1}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARTICLES = void 0;

var PARTICLES = function () {
  return {
    load: function load() {
      particlesJS.load('particles-js', 'assets/particles.json', function () {});
    }
  };
}();

exports.PARTICLES = PARTICLES;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POPUP = void 0;

var _validation = require("../partials/validation");

var _customSmartscroll = require("./custom-smartscroll");

var _ui = require("../partials/ui");

var _forms = require("./forms");

var POPUP = function () {
  var getPdfForm = $('#get-pdf-form');
  var overlay = $('#overlay-pdf');
  var closeButton = $('#get-pdf-close-button');
  var isShow = false;

  var show = function show() {
    if (!_forms.FORMS.getFormIsOpen() && !_customSmartscroll.CUSTOMSMARTSCROLL.getIsScrolling() && !isShow) {
      isShow = true;
      overlay.click(clickOnOverlay);
      closeButton.click(hide);

      _validation.VALIDATION.addFormListeners(getPdfForm[0]);

      overlay.toggleClass('overlay-hide overlay-show');

      _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(true);

      _customSmartscroll.CUSTOMSMARTSCROLL.stopScroll();
    } else if (_forms.FORMS.getFormIsOpen()) {
      document.addEventListener('formClose', waiting);
    } else if (_customSmartscroll.CUSTOMSMARTSCROLL.getIsScrolling()) {
      document.addEventListener('scrollFinish', show);
    }
  };

  var hide = function hide() {
    _validation.VALIDATION.resetForm(getPdfForm[0]);

    overlay.toggleClass('overlay-show overlay-hide');

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(false);

    _customSmartscroll.CUSTOMSMARTSCROLL.runScroll();
  };

  var waiting = function waiting() {
    showByTimeout(5000);
  };

  var clickOnOverlay = function clickOnOverlay(event) {
    if ($(event.target).closest($('#popup-pdf')).length === 0 && overlay.hasClass('overlay-show')) {
      hide();
    }
  };

  var showByTimeout = function showByTimeout(time) {
    setTimeout(function () {
      return show();
    }, time);
  };

  var showByMouseLeave = function showByMouseLeave() {
    $('#body').mouseleave(function ($event) {
      if ($event.offsetY < 0) {
        show();
      }
    });
  };

  var showByScroll = function showByScroll(anchor) {
    $(window).on('scroll', function (event) {
      if (_customSmartscroll.CUSTOMSMARTSCROLL.getIsRun() && _customSmartscroll.CUSTOMSMARTSCROLL.getId() === 3) {
        show();
      } else if (_ui.UI.isInView(anchor)) {
        show();
      }
    });
  };

  var firstVersion = function firstVersion() {
    if (window.innerWidth > 700) {
      showByTimeout(5000);
    }
  };

  var secondVersion = function secondVersion() {
    if (window.innerWidth > 700) {
      if (window.innerWidth < 1025) {
        showByTimeout(5000);
      } else {
        showByMouseLeave();
      }
    }
  };

  var thirdVersion = function thirdVersion() {
    if (window.innerWidth > 700) {
      var thirdBlock = $($('.section')[2]).find('.footer');
      showByScroll(thirdBlock);
    }
  };

  return {
    firstVersion: firstVersion,
    secondVersion: secondVersion,
    thirdVersion: thirdVersion,
    hide: hide
  };
}();

exports.POPUP = POPUP;

},{"../partials/ui":12,"../partials/validation":13,"./custom-smartscroll":2,"./forms":3}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRELOADER = void 0;

var _customSmartscroll = require("./custom-smartscroll");

var PRELOADER = function () {
  var preloader = $('#preloader');
  var wrapper = $('#wrapper');
  var preloaderEvent = new Event('preloaderStop');

  var loadPreloader = function loadPreloader() {
    preloader.load("preloader.html");

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(true);
  };

  var stopPreloader = function stopPreloader() {
    preloader.empty();
    wrapper.removeClass('loader__hidden');

    _customSmartscroll.CUSTOMSMARTSCROLL.blockScroll(false);

    window.scrollTo(0, 0);
    document.dispatchEvent(preloaderEvent);
  };

  return {
    loadPreloader: loadPreloader,
    stopPreloader: stopPreloader
  };
}();

exports.PRELOADER = PRELOADER;

},{"./custom-smartscroll":2}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERYPARAMETERS = void 0;

var _particles = require("./particles");

var _popup = require("./popup");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var QUERYPARAMETERS = function () {
  var backgrounds = {
    2: 'img/bg_2.jpg',
    3: 'img/bg_3.jpg'
  };
  var slogans = {
    2: '|Data Processing|Solutions that Boost Profit',
    3: '|Big Data|: Data Processing Solutions that Boost Profit in Retail',
    4: '|Big Data|: Data Processing Solutions that Boost Profit in Fintech',
    5: 'Data Processing Solutions that Boost Profit in |Data Integration|',
    6: '|Data Mining|: Data Processing Solutions that Boost Profit in Healthcare',
    7: 'Data Processing Solutions that Boost Profit in Automatic |Data Collection|'
  };
  var popups = {
    2: _popup.POPUP.firstVersion,
    3: _popup.POPUP.secondVersion,
    4: _popup.POPUP.thirdVersion
  };

  var setImg = function setImg(imgNumber) {
    var main = document.getElementById("section-main");

    if (backgrounds[imgNumber]) {
      main.style.background = "#000 url(".concat(backgrounds[imgNumber], ") center");
    } else {
      _particles.PARTICLES.load();
    }
  };

  var setSlogan = function setSlogan(sloganNumber) {
    var sloganChildren = document.getElementById("slogan").children;

    if (slogans[sloganNumber]) {
      slogans[sloganNumber].split('|').forEach(function (str, i) {
        return sloganChildren[i].innerText = str;
      });
    }
  };

  var setPopup = function setPopup(popupNumber) {
    document.addEventListener('preloaderStop', function () {
      if (popups[popupNumber]) {
        popups[popupNumber]();
      }
    });
  };

  return {
    getParameters: function getParameters() {
      var urlParams = new URLSearchParams(window.location.search);

      var _iterator = _createForOfIteratorHelper(urlParams.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;

          switch (key) {
            case 'img':
              setImg(urlParams.get('img'));
              break;

            case 'slogan':
              setSlogan(urlParams.get('slogan'));
              break;

            case 'pop':
              setPopup(urlParams.get('pop'));
              break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!urlParams.has('img')) {
        _particles.PARTICLES.load();
      }
    }
  };
}();

exports.QUERYPARAMETERS = QUERYPARAMETERS;

},{"./particles":5,"./popup":6}],9:[function(require,module,exports){
"use strict";

var _handlebars = require("./layout/handlebars");

var _queryParameters = require("./layout/query-parameters");

var _ui = require("./partials/ui");

var _animation = require("./layout/animation");

var _validation = require("./partials/validation");

var _preloader = require("./layout/preloader");

var _customSmartscroll = require("./layout/custom-smartscroll");

var _tracking = require("./tracking/tracking");

$(document).ready(function () {
  _preloader.PRELOADER.loadPreloader();

  _queryParameters.QUERYPARAMETERS.getParameters();

  _tracking.TRACKING.addTrackingTags();

  _handlebars.HANDLEBARS.loadPage();

  _validation.VALIDATION.addFormListeners($('#contact-us-form')[0]);
});
$(window).on('load', function () {
  setTimeout(function () {
    return _preloader.PRELOADER.stopPreloader();
  }, 1000);
  document.addEventListener('preloaderStop', function () {
    _customSmartscroll.CUSTOMSMARTSCROLL.runScroll();

    _animation.ANIMATION.onLoad();

    _ui.UI.addUIListeners();

    _tracking.TRACKING.addTracking();
  });
});

},{"./layout/animation":1,"./layout/custom-smartscroll":2,"./layout/handlebars":4,"./layout/preloader":7,"./layout/query-parameters":8,"./partials/ui":12,"./partials/validation":13,"./tracking/tracking":17}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postFetch = postFetch;
exports.fetchRetry = fetchRetry;

function postFetch(url, data) {
  return new Promise(function (resolve, reject) {
    var boundary = String(Math.random()).slice(2);
    var boundaryMiddle = '--' + boundary + '\r\n';
    var boundaryLast = '--' + boundary + '--\r\n';
    var body = ['\r\n'];

    for (var key in data) {
      // добавление поля
      body.push('Content-Disposition: form-data; name="' + key + '"\r\n\r\n' + data[key] + '\r\n');
    }

    var formatBody = body.join(boundaryMiddle) + boundaryLast; // Тело запроса готово, отправляем

    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + boundary);

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject(xhr.statusText);
      }
    };

    xhr.onerror = function () {
      return reject(xhr.statusText);
    };

    xhr.send(formatBody);
  });
}

function fetchRetry(url, data) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;
  return new Promise(function (resolve, reject) {
    function success(response) {
      resolve(response);
    }

    function failure(error) {
      limit--;

      if (limit) {
        setTimeout(fetch, delay);
      } else {
        // this time it failed for real
        reject(error);
      }
    }

    function finalHandler(finalError) {
      throw finalError;
    }

    function fetch() {
      return postFetch(url, data).then(success)["catch"](failure)["catch"](finalHandler);
    }

    fetch();
  });
}

},{}],11:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE = void 0;

var VARIABLES = _interopRequireWildcard(require("./variables"));

var _postFetch = require("./post-fetch");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SERVICE = function () {
  var dns = VARIABLES.environment.production === 'true' ? 'https://light-it.net' : 'http://light-it-new.tk';
  var api = "".concat(dns, "/api/landing");
  var consultingForm = $('#consulting-form');
  var writeUsForm = $('#write-us-form');
  var contactUsForm = $('#contact-us-form');
  var getPdfForm = $('#get-pdf-form');

  var postWriteUsForm = function postWriteUsForm(formValue) {
    return $.post("".concat(api, "/short/"), formValue);
  };

  var postConsultingForm = function postConsultingForm(formValue) {
    return $.post("".concat(api, "/recommendation/"), formValue);
  };

  var postContactUsForm = function postContactUsForm(formValue) {
    return $.post("".concat(api, "/full/"), formValue);
  };

  var postGetPdfForm = function postGetPdfForm(formValue) {
    return $.post("".concat(api, "/recommendation/"), formValue);
  };

  var postForm = function postForm(form, formValue) {
    switch (form) {
      case consultingForm[0]:
        return postConsultingForm(formValue);

      case writeUsForm[0]:
        return postWriteUsForm(formValue);

      case contactUsForm[0]:
        return postContactUsForm(formValue);

      case getPdfForm[0]:
        return postGetPdfForm(formValue);

      default:
        break;
    }
  };

  var getLocation = function getLocation() {
    return $.get("https://extreme-ip-lookup.com/json/");
  };

  var generateUserId = function generateUserId(userInfoData) {
    return (0, _postFetch.fetchRetry)("".concat(dns, "/api/visitor/"), userInfoData, 500, 3);
  };

  return {
    postForm: postForm,
    getLocation: getLocation,
    generateUserId: generateUserId
  };
}();

exports.SERVICE = SERVICE;

},{"./post-fetch":10,"./variables":15}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI = void 0;

var _handlebars = require("../layout/handlebars");

var _forms = require("../layout/forms");

var _customSmartscroll = require("../layout/custom-smartscroll");

var UI = function () {
  var partnersButtons = $('.partners-tab--wrapper');

  var _isInView = function isInView(el) {
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }

    var scroll = window.scrollY || window.pageYOffset;
    var boundsTop = el.getBoundingClientRect().top + scroll;
    var viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight
    };
    var bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight
    };
    return bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom || bounds.top <= viewport.bottom && bounds.top >= viewport.top;
  };

  var addUIListeners = function addUIListeners() {
    addPopupListeners();
    addTabsListeners();
    addTabsOnResize();
    stopSmartScrollOnResize();

    _forms.FORMS.addFormListeners();
  };

  var addPopupListeners = function addPopupListeners() {
    $('#contact-button').click(clickOnContactButton);
    $('#mouse-button').click(clickOnMouseButton);
  };

  var addTabsListeners = function addTabsListeners() {
    var serviceButtons = $('.service-tab');
    var memeButtons = $('.meme-tab--wrapper');
    serviceButtons.click({
      buttons: serviceButtons,
      name: 'services'
    }, clickOnTabs);
    memeButtons.click({
      buttons: memeButtons,
      name: 'machine'
    }, clickOnTabs);
    partnersButtons.click({
      buttons: partnersButtons,
      name: 'partners'
    }, clickOnTabs);
  };

  var clickOnContactButton = function clickOnContactButton() {
    _customSmartscroll.CUSTOMSMARTSCROLL.scrollToSection($('#contact-us'), 1500);
  };

  var clickOnMouseButton = function clickOnMouseButton() {
    _customSmartscroll.CUSTOMSMARTSCROLL.scrollToSection($("#section-services"), 800);
  };

  var clickOnTabs = function clickOnTabs(e) {
    var button = $(e.data.buttons[0].firstElementChild);
    button.removeClass('tab');
    button.toggleClass('left right');
    button.hasClass('right') ? _handlebars.HANDLEBARS.rerenderPage(0, e.data.name) : _handlebars.HANDLEBARS.rerenderPage(1, e.data.name);
    button.addClass('tab');
  };

  var addTabsOnResize = function addTabsOnResize() {
    var windowWidth = window.innerWidth;
    $(window).on('resize', function () {
      if (window.innerWidth !== windowWidth) {
        var pageNumber = 0;
        partnersButtons.each(function (buttonIndex) {
          var button = partnersButtons[buttonIndex].firstElementChild;

          if (button.classList.contains('selected')) {
            pageNumber = buttonIndex;
          }
        });

        _handlebars.HANDLEBARS.rerenderPage(pageNumber, 'partners');

        windowWidth = window.innerWidth;
      }
    });
  };

  var stopSmartScrollOnResize = function stopSmartScrollOnResize() {
    $(window).on('resize', function () {
      window.innerWidth <= 768 || window.innerHeight < 710 ? _customSmartscroll.CUSTOMSMARTSCROLL.stopScroll() : _customSmartscroll.CUSTOMSMARTSCROLL.runScroll();
    });
  };

  return {
    addUIListeners: addUIListeners,
    isInView: function isInView(el) {
      return _isInView(el);
    }
  };
}();

exports.UI = UI;

},{"../layout/custom-smartscroll":2,"../layout/forms":3,"../layout/handlebars":4}],13:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATION = void 0;

var _validators = require("./validators");

var _tracking = require("../tracking/tracking");

var _service = require("./service");

var _handlebars = require("../layout/handlebars");

var _forms = require("../layout/forms");

var VARIABLES = _interopRequireWildcard(require("./variables"));

var _userid = require("../tracking/userid");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VALIDATION = function () {
  var forms = $('form');
  var error = document.getElementsByClassName('error');
  var VALIDATIONCHECKDICTIONARY = {
    'user_name': _validators.VALIDATORS.checkNameValidity,
    'user_email': _validators.VALIDATORS.checkEmailValidity,
    'user_phone': _validators.VALIDATORS.checkPhoneValidity,
    'text': _validators.VALIDATORS.checkMessageValidity,
    'agreement': _validators.VALIDATORS.checkAgreementValidity
  };
  var VALIDATIONSHOWDICTIONARY = {
    'user_name': _validators.VALIDATORS.showNameValidity,
    'user_email': _validators.VALIDATORS.showEmailValidity,
    'user_phone': _validators.VALIDATORS.showPhoneValidity,
    'text': _validators.VALIDATORS.showMessageValidity,
    'agreement': _validators.VALIDATORS.showAgreementValidity
  };

  var addFormListeners = function addFormListeners(form) {
    addFieldsListeners(form);
    $(form).on('submit', function (event) {
      return checkFormBeforeSubmit(event, form);
    });
  };

  var addFieldsListeners = function addFieldsListeners(form) {
    Array.from(form.getElementsByClassName('field')).forEach(function (field) {
      checkFormValidityListener(form, field);
      $(field).on('blur', function () {
        return addFieldListener(field);
      });
      $(field).on('input change', function () {
        return checkFormValidityListener(form, field);
      });
    });
    $('#contact_phone').inputmask({
      mask: "+9{11,20}",
      placeholder: "",
      showMaskOnHover: false,
      clearIncomplete: true
    });
  };

  var addFieldListener = function addFieldListener(field) {
    VALIDATIONSHOWDICTIONARY[field.name](field);
    $(field).on('input', function () {
      VALIDATIONSHOWDICTIONARY[field.name](field);
    });
  };

  var checkFormValidityListener = function checkFormValidityListener(form, field) {
    var valid = 0;
    var fields = form.getElementsByClassName('field');
    VALIDATIONCHECKDICTIONARY[field.name](field);
    Array.from(fields).forEach(function (field) {
      return valid = field.valid ? valid + 1 : valid;
    });
    valid === fields.length ? form.classList.add('valid') : form.classList.remove('valid');
  };

  var resetForm = function resetForm(form) {
    Array.from(error).forEach(function (item) {
      return item.innerHTML = '';
    });
    $(form).off();
    Array.from(form.getElementsByClassName('field')).forEach(function (child) {
      $(child).off();
      $(child).blur();
    });
    form.reset();
  };

  var checkFormBeforeSubmit = function checkFormBeforeSubmit(event, form) {
    event.preventDefault();
    event.stopPropagation();
    var formValue = {};
    Array.from(form.getElementsByClassName('field')).forEach(function (field) {
      formValue[field.name] = $(field).val();
      addFieldListener(field);
    });

    if (form.classList.contains('valid')) {
      form.getElementsByTagName('button')[0].style.pointerEvents = 'none';
      formValue['visitor'] = _userid.USERID.getUserId();

      _service.SERVICE.postForm(form, formValue).done(function () {
        _handlebars.HANDLEBARS.addToast(VARIABLES.toasts.success);

        _tracking.TRACKING.sendTracking(form, true);

        resetForm(form);

        if ($('#contact-us-form')[0] === form) {
          $('#contact_phone').inputmask('remove');
          addFormListeners(form);
        }
      }).fail(function () {
        _tracking.TRACKING.sendTracking(form, false);

        _handlebars.HANDLEBARS.addToast(VARIABLES.toasts.fail);
      }).always(function () {
        _forms.FORMS.closeForm(form);

        form.getElementsByTagName('button')[0].style.pointerEvents = 'auto';
      });
    }

    return false;
  };

  return {
    addFormListeners: addFormListeners,
    resetForm: resetForm
  };
}();

exports.VALIDATION = VALIDATION;

},{"../layout/forms":3,"../layout/handlebars":4,"../tracking/tracking":17,"../tracking/userid":19,"./service":11,"./validators":14,"./variables":15}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATORS = void 0;

var VALIDATORS = function () {
  var error = document.getElementsByClassName('error');
  var errors = {
    required: 'This field cannot be empty',
    email: 'Enter a valid email address',
    phone: 'Please enter your valid phone number',
    terms: 'Please tick to proceed',
    nameMax: 'You cannot enter more than 40 characters',
    messageMax: 'Your message cannot exceed 1000 characters'
  };
  var required = /[a-zA-Z0-9-,]+/;
  var reEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var rePhone = /\(?\+[0-9]{1,3}\)? ?-?[0-9]{1,3} ?-?[0-9]{3,5} ?-?[0-9]{6}( ?-?[0-9]{3})? ?(\w{1,10}\s?\d{1,6})?/;

  var showNameValidity = function showNameValidity(name) {
    var errorName = findError('name', name);

    if (!required.test(name.value)) {
      errorName.innerHTML = errors.required;
    } else if (name.value.length > 40) {
      name.setCustomValidity(errors.nameMax);
      errorName.innerHTML = errors.nameMax;
    } else {
      name.setCustomValidity('');
      errorName.innerHTML = '';
    }
  };

  var showEmailValidity = function showEmailValidity(email) {
    var errorEmail = findError('email', email);

    if (!required.test(email.value)) {
      errorEmail.innerHTML = errors.required;
    } else if (!reEmail.test(email.value)) {
      email.setCustomValidity(errors.email);
      errorEmail.innerHTML = errors.email;
    } else {
      email.setCustomValidity('');
      errorEmail.innerHTML = '';
    }
  };

  var showMessageValidity = function showMessageValidity(message) {
    var messageError = findError('message', message);

    if (message.value.length > 1000) {
      message.setCustomValidity(errors.messageMax);
      messageError.innerHTML = errors.messageMax;
    } else {
      message.setCustomValidity('');
      messageError.innerHTML = '';
    }
  };

  var showAgreementValidity = function showAgreementValidity(agreement) {
    var agreementError = findError('agreement', agreement);

    if (!agreement.checked) {
      agreement.setCustomValidity(errors.terms);
      agreementError.innerHTML = errors.terms;
    } else {
      agreement.setCustomValidity('');
      agreementError.innerHTML = '';
    }
  };

  var showPhoneValidity = function showPhoneValidity(phone) {
    var errorPhone = findError('phone', phone);

    if (required.test(phone.value) && !rePhone.test(phone.value)) {
      phone.setCustomValidity(errors.phone);
      errorPhone.innerHTML = errors.phone;
    } else {
      phone.setCustomValidity('');
      errorPhone.innerHTML = '';
    }
  };

  var checkNameValidity = function checkNameValidity(name) {
    name.valid = required.test(name.value) && name.value.length <= 40;
  };

  var checkEmailValidity = function checkEmailValidity(email) {
    email.valid = required.test(email.value) && reEmail.test(email.value);
  };

  var checkMessageValidity = function checkMessageValidity(message) {
    message.valid = message.value.length <= 1000;
  };

  var checkAgreementValidity = function checkAgreementValidity(agreement) {
    agreement.valid = agreement.checked;
  };

  var checkPhoneValidity = function checkPhoneValidity(phone) {
    phone.valid = !required.test(phone.value) || rePhone.test(phone.value);
  };

  var findError = function findError(errorName, elem) {
    return Array.from(error).find(function (er) {
      return er.classList.contains(errorName) === true && $(er).closest(elem.form).length > 0;
    });
  };

  return {
    showNameValidity: showNameValidity,
    showEmailValidity: showEmailValidity,
    showPhoneValidity: showPhoneValidity,
    showMessageValidity: showMessageValidity,
    showAgreementValidity: showAgreementValidity,
    checkNameValidity: checkNameValidity,
    checkEmailValidity: checkEmailValidity,
    checkPhoneValidity: checkPhoneValidity,
    checkMessageValidity: checkMessageValidity,
    checkAgreementValidity: checkAgreementValidity,
    required: required
  };
}();

exports.VALIDATORS = VALIDATORS;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environment = exports.toasts = exports.partners = exports.mememachine = exports.industries2 = exports.industries1 = exports.services = void 0;
var services = [[{
  img: 'data-mining.png',
  alt: 'Data mining',
  name: 'Data mining',
  description: 'It is not enough to just extract data from its source, that is why we offer solutions that cover every step of data mining.'
}, {
  img: 'data-integration.png',
  alt: 'Data integration',
  name: 'Data integration',
  description: 'A combination of business and technical processes must always be handled carefully to deliver trusted data only.'
}, {
  img: 'automatic-data.png',
  alt: 'Automatic data collection',
  name: 'Automatic data collection',
  description: 'Data collection is often turns into a meaningless labor when not automated. We won\'t let this happen to you.'
}, {
  img: 'business-intelligence.png',
  alt: 'Business intelligence',
  name: 'Business intelligence',
  description: 'The process of data analysis must be flawless, and the better BI system your company has, the more profit you\'ll get with data.'
}], [{
  img: 'data-mining.png',
  alt: 'Data mining',
  name: 'Data mining2',
  description: 'It is not enough to just extract data from its source, that is why we offer solutions that cover every step of data mining.'
}, {
  img: 'data-integration.png',
  alt: 'Data integration',
  name: 'Data integration2',
  description: 'A combination of business and technical processes must always be handled carefully to deliver trusted data only.'
}, {
  img: 'automatic-data.png',
  alt: 'Automatic data collection',
  name: 'Automatic data collection2',
  description: 'Data collection is often turns into a meaningless labor when not automated. We won\'t let this happen to you.'
}, {
  img: 'business-intelligence.png',
  alt: 'Business intelligence',
  name: 'Business intelligence2',
  description: 'The process of data analysis must be flawless, and the better BI system your company has, the more profit you\'ll get with data.'
}]];
exports.services = services;
var industries1 = ['Banking & Finance', 'Healthcare Industry', 'Media & Advertising'];
exports.industries1 = industries1;
var industries2 = ['Retail & eCommerce', 'Enterprise Industry', 'Travel & Transportation'];
exports.industries2 = industries2;
var mememachine = {
  data: [{
    highlight: 'ANALYTIC SYSTEM',
    name: ' FOR MOST EFFECTIVE AD CAMPAIGNS',
    "class": 'mememachine-data__name-1',
    items: [{
      name: 'CLIENT’S PROBLEM',
      text: 'On the one hand, our client needed a fully-functional system that would allow their clients to set up effective ad campaigns within minutes without spending months on research. On the other hand, this new system had to automate all data gathering and analyzing processes.'
    }, {
      name: 'OUR SOLUTION',
      text: 'The result of our mutual work is a unique data processing system that does continuous market research and is the fastest one in setting ad campaigns. The developed system gives clients best recommendations on target audience, run time and a lot more, which makes campaigns highly efficient.'
    }]
  }, {
    highlight: 'WELL-ROUNDED',
    name: " DATA EXTRACTION, PROCESSING AND UPLOADING",
    "class": 'mememachine-data__name-2',
    items: [{
      name: 'CLIENT’S PROBLEM',
      text: 'Lack of automation on all stages of data processing resulted in spending the enormous amount of time and resources. Our client needed the system that allows to simultaneously process hundreds of projects. In addition, it should have the resource to process data as fast as possible.'
    }, {
      name: 'OUR SOLUTION',
      text: 'What we did was creating a convenient system that configures all required pieces of data into wholesome and understandable reports. Now, managers can work on 500 projects simultaneously and deliver them within minutes or hours instead of days using our data processing solution.'
    }]
  }],
  img: [{
    src: 'mememachine-mackbook1',
    alt: 'Laptop with red charts',
    title: 'Red charts on laptop screen'
  }, {
    src: 'mememachine-mackbook2',
    alt: 'White diagram on purple screen',
    title: 'Laptop with purple screen and white diagram'
  }],
  name: ['MEMEMACHINE', "ETL\xA0SOFTWARE"]
};
exports.mememachine = mememachine;
var partners = ['python.png', 'kibana.png', 'hbase.png', 'nodejs.png', 'grafana.png', 'keras.png', 'spark.png', 'cassandra.png', 'kafka.png', 'big_query.png', 'postgres.png', 'tensorflow.png', 'dynamodb.png', 'elasticsearch.png', 'prometheus.png'];
exports.partners = partners;
var toasts = {
  success: {
    "class": 'success',
    text: 'Thank you!\n Your message was successfully sent and we will reach out to you as soon as possible.\n'
  },
  fail: {
    "class": 'fail',
    text: 'Sorry, your message wasn’t sent for some reason. Please, try again later.\n'
  }
};
exports.toasts = toasts;
var environment = {
  development: 'false',
  production: 'true'
};
exports.environment = environment;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIES = void 0;

var COOKIES = function () {
  var getItem = function getItem(sKey) {
    if (!sKey) {
      return null;
    }

    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  };

  var setItem = function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }

    var sExpires = "";

    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;

        case String:
          sExpires = "; expires=" + vEnd;
          break;

        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }

    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  };

  var removeItem = function removeItem(sKey, sPath, sDomain) {
    if (!hasItem(sKey)) {
      return false;
    }

    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  };

  var hasItem = function hasItem(sKey) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }

    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
  };

  var keys = function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);

    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }

    return aKeys;
  };

  return {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    hasItem: hasItem,
    keys: keys
  };
}();

exports.COOKIES = COOKIES;

},{}],17:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING = void 0;

var _ui = require("../partials/ui");

var VARIABLES = _interopRequireWildcard(require("../partials/variables"));

var _userid = require("./userid");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TRACKING = function () {
  var stopWatcher;
  var scrollAnchors = $('.scroll-anchor');
  var blockAnchors = [];
  var ANCHORSDICTIONARY = ['dp_first', 'dp_services', 'dp_indusrtries', 'dp_manual', 'dp_highlights', 'dp_cases', 'dp_team', 'dp_partners', 'dp_fullcontact'];
  var googleAnalyticsId = VARIABLES.environment.production === 'true' ? 'UA-67418575-3' : 'UA-67418575-4';
  var yandexId = VARIABLES.environment.production === 'true' ? '52022618' : '52033890';
  var head = document.head;

  var clickTracking = function clickTracking(eventCategory, eventAction) {
    if (eventCategory && eventAction) {
      gtag('event', eventAction, {
        'event_category': eventCategory
      });
    }
  };

  var sendTracking = function sendTracking(form, result) {
    if (result) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-768923858/f-SWCJb3nJMBENKx0-4C',
        'value': 1.00,
        'currency': 'USD'
      });
      fbq('track', 'Lead');
      qp('track', 'GenerateLead');
    }

    addFormTracking(form, result);
    return false;
  };

  var addTrackingTags = function addTrackingTags() {
    addGoogleTags();
    addYandexTags();

    if (window && window.gtag && document) {
      _userid.USERID.userIdInit();

      document.addEventListener('userIdInit', function () {
        var userId = _userid.USERID.getUserId();

        if (userId) {
          addConfigWithUserID(userId);
        }
      });
    }
  };

  var addGoogleTags = function addGoogleTags() {
    var googleAnalyticsFirstScript = document.createElement('script');
    googleAnalyticsFirstScript.async = true;
    googleAnalyticsFirstScript.src = "https://www.googletagmanager.com/gtag/js?id=".concat(googleAnalyticsId);
    var googleAnalyticsSecondScript = document.createElement('script');
    googleAnalyticsSecondScript.innerHTML = '    window.dataLayer = window.dataLayer || [];\n' + '    function gtag(){dataLayer.push(arguments);}\n' + '    gtag(\'js\', new Date());\n' + '    gtag(\'config\', \'AW-768923858\');';
    head.appendChild(googleAnalyticsFirstScript);
    head.appendChild(googleAnalyticsSecondScript);
  };

  var addYandexTags = function addYandexTags() {
    (function (d, w, c) {
      (w[c] = w[c] || []).push(function () {
        try {
          w.yaCounter48948179 = new Ya.Metrika({
            id: yandexId,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
          });
        } catch (e) {}
      });

      var n = d.getElementsByTagName('script')[0],
          s = d.createElement('script'),
          f = function f() {
        n.parentNode.insertBefore(s, n);
      };

      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://mc.yandex.ru/metrika/watch.js';

      if (w.opera == '[object Opera]') {
        d.addEventListener('DOMContentLoaded', f, false);
      } else {
        f();
      }
    })(document, window, 'yandex_metrika_callbacks');

    var yandexAnalyticsFirstScript = document.createElement('noscript');
    yandexAnalyticsFirstScript.innerHTML = "<div><img src=\"https://mc.yandex.ru/watch/".concat(yandexId, "\" style=\"position:absolute; left:-9999px;\" alt=\"\"/></div>");
    head.appendChild(yandexAnalyticsFirstScript);
  };

  var addConfigWithUserID = function addConfigWithUserID(userId) {
    var params = {
      'page_path': '/dataprocessing',
      'custom_map': {
        'dimension1': 'client_id'
      }
    };

    if (userId) {
      params.user_id = userId;
      params.client_id = userId;
    }

    window.gtag('config', googleAnalyticsId, params);
  };

  var addTracking = function addTracking() {
    $('#contact-button').click(function () {
      return clickTracking('dp_Contactus_header', 'push_button');
    });
    $('#write-button').click(function () {
      return clickTracking('dp_Envelope_icon', 'click_button');
    });
    $('#download-button').click(function () {
      return clickTracking('dp_Download_PDF', 'click_button');
    });
    addScrollTracking();
  };

  var addScrollTracking = function addScrollTracking() {
    var footerInView = $('.footer')[0];
    stopwatch(footerInView);
    $(window).on('scroll', function (event) {
      var inViewIndex = scrollAnchors.toArray().findIndex(function (sFooter) {
        return _ui.UI.isInView(sFooter);
      });

      if (scrollAnchors[inViewIndex] !== footerInView) {
        footerInView = scrollAnchors[inViewIndex];
        clearInterval(stopWatcher);
        stopwatch(footerInView, inViewIndex);
      }
    });
  };

  var stopwatch = function stopwatch(elem) {
    var elemNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var counter = Date.now();
    stopWatcher = setInterval(function () {
      if (Date.now() - counter >= 4000 && !blockAnchors.includes(elem)) {
        clickTracking(ANCHORSDICTIONARY[elemNumber], 'scroll_down');
        blockAnchors.push(elem);
        clearInterval(stopWatcher);
      }
    }, 1);
  };

  var addFormTracking = function addFormTracking(form, result) {
    switch (form) {
      case $('#consulting-form')[0]:
        result ? clickTracking('dp_PDF_sent', 'sentmail') : clickTracking('dp_PDF_sent_Error', 'sentmail_error');
        return;

      case $('#write-us-form')[0]:
        result ? clickTracking('dp_Shortform_sent', 'sentmail') : clickTracking('dp_Shortform_sent_Error', 'sentmail_error');
        return;

      case $('#contact-us-form')[0]:
        result ? clickTracking('dp_Mainform_sent', 'sentmail') : clickTracking('dp_Mainform_sent_Error', 'sentmail_error');
        return;

      case $('#get-pdf-form')[0]:
        result ? clickTracking('dp_PDFpopup_sent', 'sentmail') : clickTracking('dp_PDFpopup_sent_Error', 'sentmail_error');
        return;

      default:
        break;
    }
  };

  return {
    addTracking: addTracking,
    sendTracking: sendTracking,
    addTrackingTags: addTrackingTags
  };
}();

exports.TRACKING = TRACKING;

},{"../partials/ui":12,"../partials/variables":15,"./userid":19}],18:[function(require,module,exports){
'use strict'; //////////////
// Constants
/////////////

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var LIBVERSION = '0.7.19',
    EMPTY = '',
    UNKNOWN = '?',
    FUNC_TYPE = 'function',
    UNDEF_TYPE = 'undefined',
    OBJ_TYPE = 'object',
    STR_TYPE = 'string',
    MAJOR = 'major',
    // deprecated
MODEL = 'model',
    NAME = 'name',
    TYPE = 'type',
    VENDOR = 'vendor',
    VERSION = 'version',
    ARCHITECTURE = 'architecture',
    CONSOLE = 'console',
    MOBILE = 'mobile',
    TABLET = 'tablet',
    SMARTTV = 'smarttv',
    WEARABLE = 'wearable',
    EMBEDDED = 'embedded'; ///////////
// Helper
//////////

var util = {
  extend: function extend(regexes, extensions) {
    var margedRegexes = {};

    for (var i in regexes) {
      if (extensions[i] && extensions[i].length % 2 === 0) {
        margedRegexes[i] = extensions[i].concat(regexes[i]);
      } else {
        margedRegexes[i] = regexes[i];
      }
    }

    return margedRegexes;
  },
  has: function has(str1, str2) {
    if (typeof str1 === "string") {
      return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
    } else {
      return false;
    }
  },
  lowerize: function lowerize(str) {
    return str.toLowerCase();
  },
  major: function major(version) {
    return _typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
  },
  trim: function trim(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }
}; ///////////////
// Map helper
//////////////

var mapper = {
  rgx: function rgx(ua, arrays) {
    //var result = {},
    var i = 0,
        j,
        k,
        p,
        q,
        matches,
        match; //, args = arguments;

    /*// construct object barebones
    for (p = 0; p < args[1].length; p++) {
        q = args[1][p];
        result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
    }*/
    // loop through all regexes maps

    while (i < arrays.length && !matches) {
      var regex = arrays[i],
          // even sequence (0,2,4,..)
      props = arrays[i + 1]; // odd sequence (1,3,5,..)

      j = k = 0; // try matching uastring with regexes

      while (j < regex.length && !matches) {
        matches = regex[j++].exec(ua);

        if (!!matches) {
          for (p = 0; p < props.length; p++) {
            match = matches[++k];
            q = props[p]; // check if given property is actually array

            if (_typeof(q) === OBJ_TYPE && q.length > 0) {
              if (q.length == 2) {
                if (_typeof(q[1]) == FUNC_TYPE) {
                  // assign modified match
                  this[q[0]] = q[1].call(this, match);
                } else {
                  // assign given value, ignore regex match
                  this[q[0]] = q[1];
                }
              } else if (q.length == 3) {
                // check whether function or regex
                if (_typeof(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                  // call function (usually string mapper)
                  this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                } else {
                  // sanitize match using given regex
                  this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                }
              } else if (q.length == 4) {
                this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
              }
            } else {
              this[q] = match ? match : undefined;
            }
          }
        }
      }

      i += 2;
    } // console.log(this);
    //return this;

  },
  str: function str(_str, map) {
    for (var i in map) {
      // check if array
      if (_typeof(map[i]) === OBJ_TYPE && map[i].length > 0) {
        for (var j = 0; j < map[i].length; j++) {
          if (util.has(map[i][j], _str)) {
            return i === UNKNOWN ? undefined : i;
          }
        }
      } else if (util.has(map[i], _str)) {
        return i === UNKNOWN ? undefined : i;
      }
    }

    return _str;
  }
}; ///////////////
// String map
//////////////

var maps = {
  browser: {
    oldsafari: {
      version: {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
      }
    }
  },
  device: {
    amazon: {
      model: {
        'Fire Phone': ['SD', 'KF']
      }
    },
    sprint: {
      model: {
        'Evo Shift 4G': '7373KT'
      },
      vendor: {
        'HTC': 'APA',
        'Sprint': 'Sprint'
      }
    }
  },
  os: {
    windows: {
      version: {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': ['NT 5.1', 'NT 5.2'],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': ['NT 6.4', 'NT 10.0'],
        'RT': 'ARM'
      }
    }
  }
}; //////////////
// Regex map
/////////////

var regexes = {
  browser: [[// Presto based
  /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
  /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
  /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
  /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
  ], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
  ], [[NAME, 'Opera Mini'], VERSION], [/\s(opr)\/([\w\.]+)/i // Opera Webkit
  ], [[NAME, 'Opera'], VERSION], [// Mixed
  /(kindle)\/([\w\.]+)/i, // Kindle
  /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
  // Trident based
  /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser/Baidu
  /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
  // Webkit/KHTML based
  /(rekonq)\/([\w\.]*)/i, // Rekonq
  /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
  ], [NAME, VERSION], [/(konqueror)\/([\w\.]+)/i // Konqueror
  ], [[NAME, 'Konqueror'], VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
  ], [[NAME, 'IE'], VERSION], [/(edge|edgios|edga)\/((\d+)?[\w\.]+)/i // Microsoft Edge
  ], [[NAME, 'Edge'], VERSION], [/(yabrowser)\/([\w\.]+)/i // Yandex
  ], [[NAME, 'Yandex'], VERSION], [/(puffin)\/([\w\.]+)/i // Puffin
  ], [[NAME, 'Puffin'], VERSION], [/(focus)\/([\w\.]+)/i // Firefox Focus
  ], [[NAME, 'Firefox Focus'], VERSION], [/(opt)\/([\w\.]+)/i // Opera Touch
  ], [[NAME, 'Opera Touch'], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
  ], [[NAME, 'UCBrowser'], VERSION], [/(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
  ], [[NAME, /_/g, ' '], VERSION], [/(micromessenger)\/([\w\.]+)/i // WeChat
  ], [[NAME, 'WeChat'], VERSION], [/(brave)\/([\w\.]+)/i // Brave browser
  ], [[NAME, 'Brave'], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i // QQBrowserLite
  ], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
  ], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
  ], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i // Baidu Browser
  ], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i // 2345 Browser
  ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i // SouGouBrowser
  ], [NAME], [/(LBBROWSER)/i // LieBao Browser
  ], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
  ], [VERSION, [NAME, 'MIUI Browser']], [/;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
  ], [VERSION, [NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
  /android.+(line)\/([\w\.]+)\/iab/i // Line App for Android
  ], [NAME, VERSION], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
  ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
  ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [// Oculus / Samsung Browser
  /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
  ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
  ], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i // Dolphin
  ], [[NAME, 'Dolphin'], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
  ], [[NAME, 'Chrome'], VERSION], [/(coast)\/([\w\.]+)/i // Opera Coast
  ], [[NAME, 'Opera Coast'], VERSION], [/fxios\/([\w\.-]+)/i // Firefox for iOS
  ], [VERSION, [NAME, 'Firefox']], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
  ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
  ], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
  ], [[NAME, 'GSA'], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
  ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
  /(navigator|netscape)\/([\w\.-]+)/i // Netscape
  ], [[NAME, 'Netscape'], VERSION], [/(swiftfox)/i, // Swiftfox
  /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
  /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
  /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla
  // Other
  /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
  /(links)\s\(([\w\.]+)/i, // Links
  /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
  /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
  /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
  ], [NAME, VERSION]
  /* /////////////////////
  // Media players BEGIN
  ////////////////////////
  , [
  /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
  /(coremedia) v((\d+)[\w\._]+)/i
  ], [NAME, VERSION], [
  /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
  ], [NAME, VERSION], [
  /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
  ], [NAME, VERSION], [
  /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                      // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                      // NSPlayer/PSP-InternetRadioPlayer/Videos
  /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
  /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
  /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
  ], [NAME, VERSION], [
  /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
  ], [NAME, VERSION], [
  /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
  ], [[NAME, 'Flip Player'], VERSION], [
  /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                      // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
  ], [NAME], [
  /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                      // Gstreamer
  ], [NAME, VERSION], [
  /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
  /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                      // Java/urllib/requests/wget/cURL
  /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
  ], [NAME, VERSION], [
  /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
  ], [[NAME, /_/g, ' '], VERSION], [
  /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                      // MPlayer SVN
  ], [NAME, VERSION], [
  /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
  ], [NAME, VERSION], [
  /(mplayer)/i,                                                       // MPlayer (no other info)
  /(yourmuze)/i,                                                      // YourMuze
  /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
  ], [NAME], [
  /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
  ], [NAME, VERSION], [
  /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
  ], [NAME, VERSION], [
  /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
  ], [NAME, VERSION], [
  /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
  /(winamp)\s((\d+)[\w\.-]+)/i,
  /(winamp)mpeg\/((\d+)[\w\.-]+)/i
  ], [NAME, VERSION], [
  /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                      // inlight radio
  ], [NAME], [
  /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                      // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                      // SoundTap/Totem/Stagefright/Streamium
  ], [NAME, VERSION], [
  /(smp)((\d+)[\d\.]+)/i                                              // SMP
  ], [NAME, VERSION], [
  /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
  /(vlc)\/((\d+)[\w\.-]+)/i,
  /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
  /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
  /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
  ], [NAME, VERSION], [
  /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
  /(windows-media-player)\/((\d+)[\w\.-]+)/i
  ], [[NAME, /-/g, ' '], VERSION], [
  /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                      // Windows Media Server
  ], [VERSION, [NAME, 'Windows']], [
  /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
  ], [NAME, VERSION], [
  /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
  /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
  ], [[NAME, 'rad.io'], VERSION]
  //////////////////////
  // Media players END
  ////////////////////*/
  ],
  cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
  ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
  ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32
  ], [[ARCHITECTURE, 'ia32']], [// PocketPC mistakenly identified as PowerPC
  /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
  ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
  ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
  ], [[ARCHITECTURE, util.lowerize]]],
  device: [[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i // iPad/PlayBook
  ], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/ // iPad
  ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i // Apple TV
  ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(archos)\s(gamepad2?)/i, // Archos
  /(hp).+(touchpad)/i, // HP TouchPad
  /(hp).+(tablet)/i, // HP Tablet
  /(kindle)\/([\w\.]+)/i, // Kindle
  /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
  /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
  ], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i // Kindle Fire HD
  ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i // Fire Phone
  ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/android.+aft([bms])\sbuild/i // Fire TV
  ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
  ], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i // iPod/iPhone
  ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, // BlackBerry
  /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
  /(hp)\s([\w\s]+\w)/i, // HP iPAQ
  /(asus)-?(\w+)/i // Asus
  ], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i // BlackBerry 10
  ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [// Asus Tablets
  /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
  /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/\s(ouya)\s/i, // Ouya
  /(nintendo)\s([wids3u]+)/i // Nintendo
  ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i // Nvidia
  ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i // Playstation
  ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i // Sprint Phones
  ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i // Lenovo tablets
  ], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i, // HTC
  /(zte)-(\w*)/i, // ZTE
  /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
  ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/(nexus\s9)/i // HTC Nexus 9
  ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i // Huawei
  ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
  ], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
  ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
  ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [// Motorola
  /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
  ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
  ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [// Samsung
  /smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
  ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
  /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i // Acer
  ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
  ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
  ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i // LG SmartTV
  ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, // LG
  /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
  ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [/linux;.+((jolla));/i // Jolla
  ], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i // Pebble
  ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
  ], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i // Google Chromecast
  ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [/android.+;\s(glass)\s\d/i // Google Glass
  ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/android.+;\s(pixel c)[\s)]/i // Google Pixel C
  ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/android.+;\s(pixel( [23])?( xl)?)\s/i // Google Pixel
  ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
  /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
  /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, // Xiaomi Mi
  /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i // Redmi Phones
  ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i // Mi Pad tablets
  ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i // Meizu Tablet
  ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [/(mz)-([\w-]{2,})/i // Meizu Phone
  ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [/android.+a000(1)\s+build/i, // OnePlus
  /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
  ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
  ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
  ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
  ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
  ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
  ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
  ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
  ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
  ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
  ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
  ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
  ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
  /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
  ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/android.+;\s(PH-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
  /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
  ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
  ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
  ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
  ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
  ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
  ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
  ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
  /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
  ], [[TYPE, util.lowerize], VENDOR, MODEL], [/[\s\/\(](smart-?tv)[;\)]/i // SmartTV
  ], [[TYPE, SMARTTV]], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
  ], [MODEL, [VENDOR, 'Generic']]
  /*//////////////////////////
      // TODO: move to string map
      ////////////////////////////
      /(C6603)/i                                                          // Sony Xperia Z C6603
      ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
      /(C6903)/i                                                          // Sony Xperia Z 1
      ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
      /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
      ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
      /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
      ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
      /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
      ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
      /(SM-G313HZ)/i                                                      // Samsung Galaxy V
      ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
      /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
      ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
      /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
      ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
      /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
      ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
      /(T3C)/i                                                            // Advan Vandroid T3C
      ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
      /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
      ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
      /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
      ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
      /(V972M)/i                                                          // ZTE V972M
      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
      /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [
      /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
      ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
      /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [
      /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
      ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
      /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
      ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
      /////////////
      // END TODO
      ///////////*/
  ],
  engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
  ], [VERSION, [NAME, 'EdgeHTML']], [/webkit\/537\.36.+chrome\/(?!27)/i // Blink
  ], [[NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
  /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
  /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
  /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
  ], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
  ], [VERSION, NAME]],
  os: [[// Windows based
  /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
  ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
  /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
  /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [// Mobile/Embedded OS
  /\((bb)(10);/i // BlackBerry 10
  ], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, // Blackberry
  /(tizen)[\/\s]([\w\.]+)/i, // Tizen
  /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
  /linux;.+(sailfish);/i // Sailfish OS
  ], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i // Symbian
  ], [[NAME, 'Symbian'], VERSION], [/\((series40);/i // Series 40
  ], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
  ], [[NAME, 'Firefox OS'], VERSION], [// Console
  /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation
  // GNU/Linux based
  /(mint)[\/\s\(]?(\w*)/i, // Mint
  /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
  /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
  // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
  /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
  /(gnu)\s?([\w\.]*)/i // GNU
  ], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
  ], [[NAME, 'Chromium OS'], VERSION], [// Solaris
  /(sunos)\s?([\w\.\d]*)/i // Solaris
  ], [[NAME, 'Solaris'], VERSION], [// BSD based
  /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
  ], [NAME, VERSION], [/(haiku)\s(\w+)/i // Haiku
  ], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
  ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
  ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Other
  /((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
  /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
  /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
  /(unix)\s?([\w\.]*)/i // UNIX
  ], [NAME, VERSION]]
}; /////////////////
// Constructor
////////////////

/*
var Browser = function (name, version) {
    this[NAME] = name;
    this[VERSION] = version;
};
var CPU = function (arch) {
    this[ARCHITECTURE] = arch;
};
var Device = function (vendor, model, type) {
    this[VENDOR] = vendor;
    this[MODEL] = model;
    this[TYPE] = type;
};
var Engine = Browser;
var OS = Browser;
*/

var UAParser = function UAParser(uastring, extensions) {
  if (_typeof(uastring) === 'object') {
    extensions = uastring;
    uastring = undefined;
  }

  if (!(this instanceof UAParser)) {
    return new UAParser(uastring, extensions).getResult();
  }

  var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
  var rgxmap = extensions ? util.extend(regexes, extensions) : regexes; //var browser = new Browser();
  //var cpu = new CPU();
  //var device = new Device();
  //var engine = new Engine();
  //var os = new OS();

  this.getBrowser = function () {
    var browser = {
      name: undefined,
      version: undefined
    };
    mapper.rgx.call(browser, ua, rgxmap.browser);
    browser.major = util.major(browser.version); // deprecated

    return browser;
  };

  this.getCPU = function () {
    var cpu = {
      architecture: undefined
    };
    mapper.rgx.call(cpu, ua, rgxmap.cpu);
    return cpu;
  };

  this.getDevice = function () {
    var device = {
      vendor: undefined,
      model: undefined,
      type: undefined
    };
    mapper.rgx.call(device, ua, rgxmap.device);
    return device;
  };

  this.getEngine = function () {
    var engine = {
      name: undefined,
      version: undefined
    };
    mapper.rgx.call(engine, ua, rgxmap.engine);
    return engine;
  };

  this.getOS = function () {
    var os = {
      name: undefined,
      version: undefined
    };
    mapper.rgx.call(os, ua, rgxmap.os);
    return os;
  };

  this.getResult = function () {
    return {
      ua: this.getUA(),
      browser: this.getBrowser(),
      engine: this.getEngine(),
      os: this.getOS(),
      device: this.getDevice(),
      cpu: this.getCPU()
    };
  };

  this.getUA = function () {
    return ua;
  };

  this.setUA = function (uastring) {
    ua = uastring; //browser = new Browser();
    //cpu = new CPU();
    //device = new Device();
    //engine = new Engine();
    //os = new OS();

    return this;
  };

  return this;
};

UAParser.VERSION = LIBVERSION;
UAParser.BROWSER = {
  NAME: NAME,
  MAJOR: MAJOR,
  // deprecated
  VERSION: VERSION
};
UAParser.CPU = {
  ARCHITECTURE: ARCHITECTURE
};
UAParser.DEVICE = {
  MODEL: MODEL,
  VENDOR: VENDOR,
  TYPE: TYPE,
  CONSOLE: CONSOLE,
  MOBILE: MOBILE,
  SMARTTV: SMARTTV,
  TABLET: TABLET,
  WEARABLE: WEARABLE,
  EMBEDDED: EMBEDDED
};
UAParser.ENGINE = {
  NAME: NAME,
  VERSION: VERSION
};
UAParser.OS = {
  NAME: NAME,
  VERSION: VERSION
}; //UAParser.Utils = util;
///////////
// Export
//////////
// check js environment

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) !== UNDEF_TYPE) {
  // nodejs env
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) !== UNDEF_TYPE && module.exports) {
    exports = module.exports = UAParser;
  } // TODO: test!!!!!!!!

  /*
  if (require && require.main === module && process) {
      // cli
      var jsonize = function (arr) {
          var res = [];
          for (var i in arr) {
              res.push(new UAParser(arr[i]).getResult());
          }
          process.stdout.write(JSON.stringify(res, null, 2) + '\n');
      };
      if (process.stdin.isTTY) {
          // via args
          jsonize(process.argv.slice(2));
      } else {
          // via pipe
          var str = '';
          process.stdin.on('readable', function() {
              var read = process.stdin.read();
              if (read !== null) {
                  str += read;
              }
          });
          process.stdin.on('end', function () {
              jsonize(str.replace(/\n$/, '').split('\n'));
          });
      }
  }
  */


  exports.UAParser = UAParser;
} else {
  // requirejs env (optional)
  if ((typeof define === "undefined" ? "undefined" : _typeof(define)) === FUNC_TYPE && define.amd) {
    define(function () {
      return UAParser;
    });
  } else if (window) {
    // browser env
    window.UAParser = UAParser;
  }
} // jQuery/Zepto specific (optional)
// Note:
//   In AMD env the global scope should be kept clean, but jQuery is an exception.
//   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
//   and we should catch that.


var $ = window && (window.jQuery || window.Zepto);

if (_typeof($) !== UNDEF_TYPE && !$.ua) {
  var parser = new UAParser();
  $.ua = parser.getResult();

  $.ua.get = function () {
    return parser.getUA();
  };

  $.ua.set = function (uastring) {
    parser.setUA(uastring);
    var result = parser.getResult();

    for (var prop in result) {
      $.ua[prop] = result[prop];
    }
  };
}

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USERID = void 0;

var _cookies = require("./cookies");

var _uaParser = require("./ua-parser");

var _service = require("../partials/service");

var USERID = function () {
  var _userIdLabel = 'light-it-user-id';
  var userIdEvent = new Event('userIdInit');

  var _userId,
      _expires,
      _path,
      _domain,
      _secure = null;

  var userIdInit = function userIdInit() {
    var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.domain;
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
    var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2147483647;
    var secure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _expires = expires;
    _path = path;
    _domain = domain;
    _secure = secure;

    _saveUserId();
  };

  var _saveUserId = function _saveUserId() {
    var userIdFromCookies = _getUserIdFromCookies();

    if (!!userIdFromCookies) {
      _userId = userIdFromCookies;
      setTimeout(function () {
        return document.dispatchEvent(userIdEvent);
      }, 1000);
    } else {
      _generateUserId().then(function (userId) {
        _addUserIdToCookies(userId);

        _userId = userId;
        document.dispatchEvent(userIdEvent);
      });
    }
  };

  var _getUserIdFromCookies = function _getUserIdFromCookies() {
    return _cookies.COOKIES.getItem(_userIdLabel);
  };

  var _addUserIdToCookies = function _addUserIdToCookies(userId) {
    if (userId) {
      _cookies.COOKIES.setItem(_userIdLabel, userId, _expires, _path, _domain, _secure);
    }
  };

  var _deleteUserIdFromCookies = function _deleteUserIdFromCookies() {
    _cookies.COOKIES.removeItem(_userIdLabel, _path, _domain);
  };

  var _generateUserId = function _generateUserId() {
    var result = null;
    var parsUa = (0, _uaParser.UAParser)(window.navigator.userAgent);
    var userInfoData = {
      marketing_source: document.referrer || '',
      source: window.location.href,
      platform: parsUa.device.type || 'desktop',
      os: parsUa.os.name + ' ' + parsUa.os.version,
      browser: parsUa.browser.name + ' ' + parsUa.browser.version,
      browser_lang: window.navigator.language
    };
    return _service.SERVICE.generateUserId(userInfoData).then(function (response) {
      return JSON.parse(response).id;
    })["catch"](function (error) {
      return console.log('Error fetch UserInfo: ' + error);
    });
  };

  return {
    userIdInit: userIdInit,
    getUserId: function getUserId() {
      return _userId;
    }
  };
}();

exports.USERID = USERID;

},{"../partials/service":11,"./cookies":16,"./ua-parser":18}]},{},[9]);
